import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
    Container,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    // UncontrolledDropdown,
    // DropdownToggle,
    // DropdownMenu,
    // DropdownItem 
} from 'reactstrap';

// The Header creates links that can be used to navigate
// between routes.
class Header extends Component {
    constructor(props) {
        super(props);
    
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (
            <header>
                {/* <nav>
                    <ul>
                        <li><Link to='/'>Home</Link></li>
                        <li><Link to='/shop'>Shop</Link></li>
                        <li><Link to='/products'>Products</Link></li>
                    </ul>
                </nav> */}
                <Navbar expand="md" fixed="top" className="site-header">
                    <Container>
                        <NavbarBrand tag={Link} to="/">
                            <svg className="site-header-icon" viewBox="0 0 70 60" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <g stroke="none" fill="none" fillRule="evenodd">
                                    <path
                                        className="svg-stroke"
                                        d="m 8.079616,27.493906 q 1.2192,0 2.0828,-0.4064 0.8636,-0.4572 1.4224,-1.1176 0.6096,-0.7112 0.8636,-1.5748 0.3048,-0.9144 0.3048,-1.8288 v -9.144 q 0,-2.0828 0.4572,-3.7083998 0.4572,-1.6256 1.5748,-2.6924 1.1176,-1.1176 2.9464,-1.6763999 1.8796,-0.6096 4.6228,-0.6096 h 0.2032 v 3.7083999 q -2.8956,0 -4.1656,1.0668 -1.2192,1.0159998 -1.2192,3.9623998 v 7.8232 q 0,3.3528 -0.9144,5.1816 -0.8636,1.8288 -2.4892,2.8448 1.6256,1.016 2.4892,2.8448 0.9144,1.8288 0.9144,5.1816 v 7.8232 q 0,2.9464 1.2192,3.9624 1.27,1.0668 4.1656,1.0668 v 3.7084 h -0.2032 q -2.7432,0 -4.6228,-0.5588 -1.8288,-0.5588 -2.9464,-1.6764 -1.1176,-1.1176 -1.5748,-2.7432 -0.4572,-1.6256 -0.4572,-3.7084 v -9.144 q 0,-0.9144 -0.3048,-1.778 -0.254,-0.9144 -0.8636,-1.5748 -0.5588,-0.7112 -1.4224,-1.1176 -0.8636,-0.4572 -2.0828,-0.4572 z"
                                    />
                                    <path
                                        className="svg-stroke"
                                        d="M 27.382822,44.511906 V 9.3075062 H 48.617221 V 13.523906 H 32.310422 v 10.6172 h 14.478 v 4.1656 h -14.478 v 16.2052 z"
                                    />
                                    <path
                                        className="svg-stroke"
                                        d="m 65.18358,31.151506 q -1.2192,0 -2.0828,0.4572 -0.8636,0.4064 -1.4732,1.1176 -0.5588,0.6604 -0.8636,1.5748 -0.254,0.8636 -0.254,1.778 v 9.144 q 0,2.0828 -0.4572,3.7084 -0.4572,1.6256 -1.5748,2.7432 -1.1176,1.1176 -2.9972,1.6764 -1.8288,0.5588 -4.572,0.5588 h -0.2032 v -3.7084 q 2.8956,0 4.1148,-1.0668 1.27,-1.016 1.27,-3.9624 v -7.8232 q 0,-3.3528 0.8636,-5.1816 0.9144,-1.8288 2.54,-2.8448 -1.6256,-1.016 -2.54,-2.8448 -0.8636,-1.8288 -0.8636,-5.1816 v -7.8232 q 0,-2.9464 -1.27,-3.9623998 -1.2192,-1.0668 -4.1148,-1.0668 V 4.7355063 h 0.2032 q 2.7432,0 4.572,0.6096 1.8796,0.5587999 2.9972,1.6763999 1.1176,1.0668 1.5748,2.6924 0.4572,1.6255998 0.4572,3.7083998 v 9.144 q 0,0.9144 0.254,1.8288 0.3048,0.8636 0.8636,1.5748 0.6096,0.6604 1.4732,1.1176 0.8636,0.4064 2.0828,0.4064 z"
                                    />
                                </g>
                            </svg>
                            Dhka Shop
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink className="site-header-nav-item" tag={Link} to="/produk">Produk</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className="site-header-nav-item" tag={Link} to="/order" >Cara Order</NavLink>
                                </NavItem>
                                {/* <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret>
                                    Options
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                    <DropdownItem>
                                        Option 1
                                    </DropdownItem>
                                    <DropdownItem>
                                        Option 2
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem>
                                        Reset
                                    </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown> */}
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/containers/Header.jsx